import {
  CREATE_ARTICLE_LOADING,
  CREATE_ARTICLE_SUCCESS,
  CREATE_ARTICLE_FAIL,
  GET_ALL_ARTICLES,
  GET_ONE_ARTICLE,
  GET_ALL_ARTICLES_FAIL,
  GET_ALL_ARTICLES_LOADING,
  GET_ONE_ARTICLE_FAIL,
  GET_ONE_ARTICLE_LOADING,
} from "../actionTypes/actionTypes";

const initialState = {
  article: {},
  pending: false,
  error: null,
};

/* istanbul ignore next */
export const createArticleReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_ARTICLE_LOADING:
      return {
        ...state,
        pending: true,
        article: {},
        error: null,
      };

    case CREATE_ARTICLE_SUCCESS:
      return {
        ...state,
        pending: false,
        article: action.payload,
        error: null,
      };

    case CREATE_ARTICLE_FAIL:
      return {
        ...state,
        pending: false,
        article: {},
        error: action.payload,
      };

    default:
      return state;
  }
};

export const fetchArticlesReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ALL_ARTICLES_LOADING:
      return {
        ...state,
        pending: true,
        article: {},
        error: null,
      };

    case GET_ALL_ARTICLES:
      return {
        // ...state,
        pending: false,
        article: action.payload,
        error: null,
      };
    case GET_ALL_ARTICLES_FAIL:
      return {
        ...state,
        pending: false,
        article: {},
        error: action.payload,
      };
    default:
      return state;
  }
};

export const fetchOneArticleReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ONE_ARTICLE_LOADING:
      return {
        ...state,
        pending: true,
        article: {},
        error: null,
      };
    case GET_ONE_ARTICLE:
      return {
        ...state,
        pending: false,
        article: action.payload,
        error: null,
      };
    case GET_ONE_ARTICLE_FAIL:
      return {
        ...state,
        pending: false,
        article: {},
        error: action.payload,
      };
    default:
      return state;
  }
};
